import { motion } from 'framer-motion';
import classNames from 'classnames';
var Backdrop = function (_a) {
    var children = _a.children, onClick = _a.onClick, _b = _a.center, center = _b === void 0 ? false : _b;
    return (<motion.div onClick={onClick} className={classNames('fixed top-0 left-0 z-[110] h-screen w-screen bg-brand-01 bg-opacity-70', center && 'flex-center')} initial={{ opacity: 0 }} animate={{ opacity: 1 }} exit={{ opacity: 0 }}>
      {children}
    </motion.div>);
};
export default Backdrop;
